// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.navbar-light .navbar-toggler-icon{
  background-color: rgb(53, 69, 238);
  border-radius: 5px;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

input[type=file]::file-selector-button {
  transform: translate(-100%);
  background: #3545EE;
  border: 2px solid #3545EE;
  border-radius: 20px;
  color: white;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  padding: 5px 10px;
  margin: 3px 3px 3px 99%;
  content: 'Upload';
}

button:disabled {
  opacity: 0.5;
}

@media screen and (min-width: 400px) {
  .w-sm-25 {
    width: 25% !important;
  }

  .w-sm-100 {
    width: 100% !important;
  }
}

@media screen and (min-width: 768px) {
  .w-md-100 {
    width: 100% !important;
  }

  .w-md-50 {
    width: 50% !important;
  }

  .w-md-25 {
    width: 30% !important;
  }

}

@media screen and (min-width: 992px) {
  .w-lg-100 {
    width: 100% !important;
  }

  .w-lg-50 {
    width: 50% !important;
  }

  .w-lg-25 {
    width: 30% !important;
  }


}

@media screen and (max-width: 992px) {
  .navbar {
    position: absolute !important;
    z-index: 20;
    width: 100vw;
  }

  .responsive-navbar {
    margin-top: 70px;
    max-width: 100vw;
  }
}

.checkbox {
  opacity: 0;
  position: absolute;
}

.checkbox-label {
  background-color: #111;
  width: 60px;
  height: 26px;
  border-radius: 50px;
  position: relative;
  padding: 5px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.fa-moon {
  color: #f1c40f;
}

.fa-sun {
  color: #f39c12;
}

.checkbox-label .ball {
  background-color: #fff;
  width: 22px;
  height: 22px;
  position: absolute;
  left: 2px;
  top: 2px;
  border-radius: 50%;
  transition: transform 0.2s linear;
}

.checkbox:checked+.checkbox-label .ball {
  transform: translateX(33px);
}

#nprogress {
  pointer-events: 'none';
}

#nprogress .bar {
  height: 3;
  left: 0;
  position: 'fixed';
  top: 0;
  width: '100%';
  z-index: 2000;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}


.cb{
  color: #3A49EE;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;AAEF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;;AAGF;;AAEA;EACE;IACE,6BAA6B;IAC7B,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,MAAM;EACN,aAAa;EACb,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE,cAAc;AAChB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.navbar-light .navbar-toggler-icon{\n  background-color: rgb(53, 69, 238);\n  border-radius: 5px;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\ninput[type=file]::file-selector-button {\n  transform: translate(-100%);\n  background: #3545EE;\n  border: 2px solid #3545EE;\n  border-radius: 20px;\n  color: white;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  padding: 5px 10px;\n  margin: 3px 3px 3px 99%;\n  content: 'Upload';\n}\n\nbutton:disabled {\n  opacity: 0.5;\n}\n\n@media screen and (min-width: 400px) {\n  .w-sm-25 {\n    width: 25% !important;\n  }\n\n  .w-sm-100 {\n    width: 100% !important;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .w-md-100 {\n    width: 100% !important;\n  }\n\n  .w-md-50 {\n    width: 50% !important;\n  }\n\n  .w-md-25 {\n    width: 30% !important;\n  }\n\n}\n\n@media screen and (min-width: 992px) {\n  .w-lg-100 {\n    width: 100% !important;\n  }\n\n  .w-lg-50 {\n    width: 50% !important;\n  }\n\n  .w-lg-25 {\n    width: 30% !important;\n  }\n\n\n}\n\n@media screen and (max-width: 992px) {\n  .navbar {\n    position: absolute !important;\n    z-index: 20;\n    width: 100vw;\n  }\n\n  .responsive-navbar {\n    margin-top: 70px;\n    max-width: 100vw;\n  }\n}\n\n.checkbox {\n  opacity: 0;\n  position: absolute;\n}\n\n.checkbox-label {\n  background-color: #111;\n  width: 60px;\n  height: 26px;\n  border-radius: 50px;\n  position: relative;\n  padding: 5px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.fa-moon {\n  color: #f1c40f;\n}\n\n.fa-sun {\n  color: #f39c12;\n}\n\n.checkbox-label .ball {\n  background-color: #fff;\n  width: 22px;\n  height: 22px;\n  position: absolute;\n  left: 2px;\n  top: 2px;\n  border-radius: 50%;\n  transition: transform 0.2s linear;\n}\n\n.checkbox:checked+.checkbox-label .ball {\n  transform: translateX(33px);\n}\n\n#nprogress {\n  pointer-events: 'none';\n}\n\n#nprogress .bar {\n  height: 3;\n  left: 0;\n  position: 'fixed';\n  top: 0;\n  width: '100%';\n  z-index: 2000;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n.cb{\n  color: #3A49EE;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
